import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, FormGroup, Label, Input, Button, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { help } from "../../Shared/validation";
import 'react-phone-number-input/style.css';
import './Help.scss';
import HelpImage from "../../assets/help_image.png";
import { FaArrowRight } from "react-icons/fa6";
import { MdOutlineNavigateNext } from "react-icons/md";
import { GoHome } from "react-icons/go";

const Help = () => {
    const [errors, setErrors] = useState({});
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [values, setValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
    });


    // window.addEventListener('beforeunload', (event) => {
    //     event.returnValue = `Are you sure you want to leave?`;
    //   });

    // let formChanged = false;
    // myForm.addEventListener('change', () => formChanged = true);
    // window.addEventListener('beforeunload', (event) => {
    //     if (formChanged) {
    //         event.returnValue = 'You have unfinished changes!';
    //     }
    // });

    useEffect(() => {
        setTimeout(() => {
            window?.scrollTo({ top: 0, behavior: 'smooth' })
        }, 0)
        // window.onbeforeunload = function(e) {
        //     e.returnValue = 'Are you sure you want to leave?';
        // };
    }, []);

    var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

    const messageErr = (e) => {
        const newData = e?.target?.value?.replace(/^\s+/, '');
        setMessage(newData)

        if (newData === '') {
            setErrMsg('Message is required')
        }
        else {
            setErrMsg('')
        }
    }

    const handleChange = (e) => {
        const newData = { ...values };
        newData[e?.target?.id] = e?.target?.value?.replace(/^\s+/, '')?.replace(regex, '');
        errors[e?.target?.id] = null;
        setValues(newData);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (message === '') {
            setErrMsg('Message is required')
        }
        const errorsx = await help(values, message);
        setErrors(errorsx);
        if (!errMsg && !errorsx) {
            setErrMsg('')
            setErrors({})
            if (isValidPhoneNumber(phoneNumber) === true) {
                setPhoneNumber(phoneNumber);
            }
            try {
                window.location.href = (`mailto:nesiyatova@gmail.com?subject=Help request in the Nesiya Tova Website 
                                        &body=First Name: ${values?.firstName?.trim()}\n\n 
                                        Last Name: ${values?.lastName?.trim()}\n\n 
                                        Contact No. : ${phoneNumber} \n\n 
                                        Email ID: ${values?.email} \n\n
                                        Explain Your Concern: ${message?.trim()}`);
            } catch (err) {
                console.log(err)
            }
            setPhoneNumber('');
            setValues({
                firstName: '',
                lastName: '',
                email: '',
            });
            setMessage('');
        }

    }

    return (
        <div className="main_section">
            <Container>
            {/* <SearchBar /> */}
            <div className='breadcrumb_section'>
                <Container >
                     <Breadcrumb className="breadcrumb">
                        <BreadcrumbItem>
                            <Link to="/" className="breadcrumb_item1">
                            <GoHome style={{ width: "23px", height: "23px" }} />
                            <span className="breadcrumb-divider">
                                <MdOutlineNavigateNext />
                            </span>
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem active><Link to="/help" className="breadcrumb_item2">Help</Link></BreadcrumbItem>
                    </Breadcrumb>
                </Container>
            </div>
            <div className="help_section">
                <Container fluid>
                    <div className="help_box_header">
                        <h4>Help</h4>
                    </div>
                    <div className="help_box">
                        <div className="help_block">
                            {/* <h5>Title Goes Here</h5>
                            <ul>
                                <li>This is demo text, disclaimer text will take place here. Two lines of demo text.</li>
                                <li>This is demo text, disclaimer text will take place here. Two lines of demo text.</li>
                            </ul> */}
                            <div className="inquiry_form">
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup className="form_field">
                                                <Label >
                                                    First Name*
                                                </Label>
                                                <Input
                                                    id="firstName"
                                                    name="firstName"
                                                    autoComplete="off"
                                                    value={values?.firstName}
                                                    onChange={handleChange}
                                                    placeholder="First Name"
                                                    maxLength="30"
                                                    type="text"
                                                />
                                                <span className="error">
                                                    {errors?.firstName &&
                                                        errors?.firstName}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form_field">
                                                <Label>
                                                    Last Name*
                                                </Label>
                                                <Input
                                                    id="lastName"
                                                    name="lastName"
                                                    autoComplete="off"
                                                    value={values?.lastName}
                                                    onChange={handleChange}
                                                    placeholder="Last Name"
                                                    maxLength="30"
                                                    type="text"
                                                />
                                                <span className="error">
                                                    {errors?.lastName &&
                                                        errors?.lastName}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup className="form_field">
                                                <Label >
                                                    Contact No. (Optional)
                                                </Label>
                                                <PhoneInput
                                                    placeholder="Phone Number"
                                                    autoComplete="off"
                                                    value={phoneNumber}
                                                    onChange={setPhoneNumber}
                                                />
                                                <span className="error">
                                                    {phoneNumber ? (isValidPhoneNumber(phoneNumber) ? undefined : 'Enter Valid Phone Number') : undefined}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form_field">
                                                <Label>
                                                    Email ID*
                                                </Label>
                                                <Input
                                                    id="email"
                                                    name="email"
                                                    value={values?.email}
                                                    onChange={handleChange}
                                                    placeholder="Email ID"
                                                    type="text"
                                                    autoComplete="off"
                                                    autoCapitalize="none"
                                                />
                                                <span className="error">
                                                    {errors?.email &&
                                                        errors?.email}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup className="form_field">
                                                <Label>
                                                    Explain Your Concern*
                                                </Label>
                                                <Input
                                                    id="message"
                                                    name="message"
                                                    type="textarea"
                                                    autoComplete="off"
                                                    value={message}
                                                    onChange={messageErr}
                                                    maxLength="256"
                                                    placeholder="What difficulties are you facing... "
                                                />
                                                <span className="error">
                                                    {errMsg &&
                                                        errMsg}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="inquiry_btn">
                                        <Button type="submit"><span>Submit</span> <FaArrowRight style={{marginTop: "2px"}} /></Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                        <div className="help-image">
                            <img src={HelpImage} alt="" />
                        </div>
                    </div>
                </Container>
            </div>
            </Container>
        </div>
    );
};

export default Help;
